<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col md="12">
          <v-btn color="secondary" outlined class="mr-1" to="/admin/reports">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Reports
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Playlists"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="channels"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template v-slot:item.icon="{ item }">
                <i class="fa" :class="'fa-' + item.icon"></i>
              </template>
              <template v-slot:item.individual_users="{ item }">
                <span v-if="item.individual_users" class="clickable-count"
                  @click.stop="openDialog($event, item.assigned_users, 'Assigned Users')">{{ item.individual_users
                  }}</span>
                <span v-else>{{ item.individual_users }}</span>
              </template>
              <template v-slot:item.total_groups="{ item }">
                <span v-if="item.total_groups" class="clickable-count"
                  @click.stop="openDialog($event, item.groups, 'Groups')">{{ item.total_groups }}</span>
                <span v-else>{{ item.total_groups }}</span>
              </template>
              <template v-slot:item.total_users="{ item }">
                <span v-if="item.total_users" class="clickable-count"
                  @click.stop="openDialog($event, item.users, 'Users')">{{ item.total_users }}</span>
                <span v-else>{{ item.total_users }}</span>
              </template>
              <template v-slot:item.total_modules="{ item }">
                <span v-if="item.total_modules" class="clickable-count"
                  @click.stop="openDialog($event, item.modules, 'Modules')">{{ item.total_modules }}</span>
                <span v-else>{{ item.total_modules }}</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      :to="'/admin/playlist-course-report/' + item.id"
                    >
                      <v-icon small>fa-search</v-icon>
                    </v-btn>
                  </template>
                  <span>Details</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <DialogComponent
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        @close="closeDialog"
      />
    </v-container>
  </layout-basic>
</template>

<script>
import channelAPI from '@/api/channel.js';
import LayoutBasic from '@/layouts/Dashboard';
import DialogComponent from '@/components/Dialog';

export default {
  name: 'PlaylistReport',
  components: {
    LayoutBasic,
    DialogComponent
  },
  data() {
    return {
      headers: [
        { text: 'Icon', value: 'icon', sortable: false, align: 'center' },
        { text: 'Playlist', value: 'name', align: 'left' },
        { text: 'Assigned Users', value: 'individual_users', sortable: false },
        { text: 'Assigned Groups', value: 'total_groups', sortable: false },
        { text: 'Total Users', value: 'total_users', sortable: false },
        { text: 'Modules', value: 'total_modules', sortable: false },
        { text: '', value: 'id', sortable: false, align: 'end' },
      ],
      channels: [],
      pagination: {},
      loading: false,
      options: {},
      search: '',
      searchParams: '',
      dialog: false,
      dialogTitle : '',
      dialogData: [],
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options) + this.searchParams;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getChannels();
      },
      deep: true,
    },
  },
  methods: {
    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.getChannels();
    },
    applySearch() {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams = this.params + '&search=name:' + this.search;
      } else {
        this.searchParams = this.params;
      }
      this.getChannels();
    },
    getChannels() {
      this.loading = true;
      if(this.$globalConfig.APP_NAME === 'direct'){
        channelAPI.getChannels(this.params).then((resp) => {
        this.loading = false;
        this.channels = resp.data.data;
        this.pagination = resp.data.meta.pagination;
      });
      }else{
      channelAPI.getChannelsReport(this.params).then((resp) => {
        this.loading = false;
        this.channels = resp.data.data;
        this.pagination = resp.data.meta.pagination;
      });
    }
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    }
  },
};
</script>
